import {html} from 'lit-html';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import TemplateRegistry from '../template/template-registry';

// support {product} placeholder in html for data-live-* attributes scoped to product e.g <span data-live-price="{product}"></span>
TemplateRegistry.templates['html'] = (option, config, onChange) => html`
    ${unsafeHTML(option.params.html.replace(new RegExp('{product}', 'g'), config.product.id))}
`;